function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function generateGUID() {
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

function createCookie(name, value, days, domain) {
  const expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + days * 24 * 3600 * 1000);
  const expires = `; expires=${expiryDate.toGMTString()}`;
  const domainString = domain ? `; domain=${domain}` : '';
  const cookie = `${name}=${value}${expires}; path=/${domainString}; secure`;
  document.cookie = cookie;
}

function readCookie(name) {
  const cookieArray = document.cookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    const cookie = cookieArray[i].trim();
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length + 1, cookie.length);
    }
  }

  return null;
}

function whichEdge() {
  return readCookie('lecdn');
}

export default function Tracking(image, accountID, defaults = {}, domain) {
  this.image = image;
  this.account_id = accountID;
  this.defaults = defaults;
  this._tracking_images = [];
  this.session_id = null;
  this.domain = domain;
  this.init_session();
}

Tracking.prototype.replace_defaults = function(newDefaults) {
  this.defaults = newDefaults;
  return this.defaults;
};

Tracking.prototype.init_session = function() {
  // Try and find the _tracking_session cookie if it's already set.
  let sessionId = readCookie('_tracking_session');

  if (!sessionId) {
    // Generate a new one if not.
    sessionId = generateGUID();
    createCookie('_tracking_session', sessionId, 365, this.domain);
  }

  this.session_id = sessionId;

  return this;
};

Tracking.prototype.log = function() {
  const args = Array.from(arguments);
  window.console.log(args.join(' '));
};

Tracking.prototype._load_image = function(url) {
  const image = new Image();
  image.src = url;
  this._tracking_images.push(image);
};

Tracking.prototype.last_image = function() {
  if (this._tracking_images.length === 0) {
    return null;
  }
  return this._tracking_images[this._tracking_images.length - 1].src;
};

/**
 * Send events to the tracking-js client
 * @param [Array] An array consisting of two values, the first is the event
 * name or control command. The second is an optional object of params
 * attached.

 * Control commands are preferred to explicit invocation of methods
 * because it will silently fail if this module was not able to load.
 */
Tracking.prototype.push = function(event) {
  const eventName = event[0];
  const params = event.length >= 2 ? event.slice(1) : [];

  if (!(typeof eventName === 'string' || eventName instanceof String)) {
    this.log(`Invalid event name pushed - ${eventName}`);
    return this;
  }
  if (eventName === '') {
    this.log('Event name is empty');
    return this;
  }
  if (eventName === '_replace_defaults') {
    this.replace_defaults(params[0]);
    return this;
  }

  const kvs = params.length === 1 ? params[0] : {};

  kvs.page = window.location.pathname;
  kvs.location = `${window.location}`;
  kvs.title = document.title;
  kvs.edge = whichEdge();
  this.track(eventName, kvs);

  return 1;
};

Tracking.prototype.init = function(trackingEvents = []) {
  trackingEvents.forEach(trackingEvent => this.push(trackingEvent));
  return this;
};

/**
 * Adds a tracking point
 * @param eventName A string that gives a name to the tracking point
 * @param keyValues An object containing key value pairs to be added to the
 *                  query string of the url for the image representing the
 *                  tracking point
 */
Tracking.prototype.track = function(eventName, keyValues) {
  const date = new Date();
  const t = `${date.getTime()}${Math.random()}`;
  const fragments = [];

  fragments.push(`acct=${this.account_id}`);
  fragments.push(`t=${t}`);
  fragments.push(`en=${eventName}`);

  Object.keys(keyValues).forEach(key =>
    fragments.push(`${key}=${encodeURIComponent(keyValues[key])}`),
  );

  const defaults = this.defaults;
  Object.keys(defaults).forEach(key =>
    fragments.push(`${key}=${encodeURIComponent(defaults[key])}`),
  );

  fragments.push(`session_id=${this.session_id}`);

  const url = `${this.image}?${fragments.join('&')}`;
  this._load_image(url);
};

Tracking.prototype.tracked_count = function() {
  return this._tracking_images.length;
};

Tracking._guid = generateGUID;
